import request from '@/utils/request'

//志愿者申请
export function applyVoluntary(data) {
  return request({
    url: '/api/voluntary/applyVoluntary',
    method: 'post',
    data
  });
}
//获取志愿者招募发布列表--可分页
export function getVoluntaryRecruitList(params) {
  return request({
    url: '/api/voluntary/getVoluntaryRecruitList',
    method: 'get',
    params
  });
}
//志愿者报名招募
export function submitRecruitApply(data) {
  return request({
    url: '/api/voluntary/submitRecruitApply',
    method: 'post',
    data
  });
}
//获取登录用户志愿者信息
export function getVoluntaryInfo(params) {
  return request({
    url: '/api/voluntary/getVoluntaryInfo',
    method: 'get',
    params
  });
}
// 明星志愿者列表--可分页
export function getStartslist(params) {
  return request({
    url: '/api/voluntary/getStartslist',
    method: 'get',
    params
  });
}
// 明星志愿者点赞
export function makeStartsLike(params) {
  return request({
    url: '/api/voluntary/makeStartsLike',
    method: 'get',
    params
  });
}
// 获取资料列表
export function getAttachmentList(params) {
  return request({
    url: '/api/voluntary/getAttachmentList',
    method: 'get',
    params
  });
}
// 志愿者签到记录
export function getAttendanceByVisitorId(params) {
  return request({
    url: '/api/voluntary/getAttendanceByVisitorId',
    method: 'get',
    params
  });
}
// 获取分享空间列表--可分页
export function getShareSpaceList(params) {
  return request({
    url: '/api/voluntary/getShareSpaceList',
    method: 'get',
    params
  });
}
// 获取分享空间详情
export function getShareSpaceDetail(params) {
  return request({
    url: '/api/voluntary/getShareSpaceDetail',
    method: 'get',
    params
  });
}




// WEBPACK FOOTER //
// ./src/api/volunteer/index.js